import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import {
  requestAddTicketNote,
  requestGetTicketNotes,
} from "./ticketNotes.request";
import { TicketNote } from "./ticketNotes.types";

const notesQueryKey = (ticketId: string | null) => [
  SUPPORT_TICKETS_QUERY_KEY,
  "notes",
  ticketId,
];

export const useTicketNotes = (ticketId: string | null) => {
  const query = useQuery<TicketNote[], ApiServiceError<ApiError>>({
    queryKey: notesQueryKey(ticketId),
    queryFn: async () => await requestGetTicketNotes(ticketId!),
    enabled: Boolean(ticketId),
  });

  return { notes: query.data ?? [], isLoading: query.isLoading };
};

export const useAddTicketNote = (ticketId: string | null) => {
  const queryClient = useQueryClient();

  return useMutation<TicketNote, ApiServiceError<ApiError>, string>({
    mutationFn: async (text: string) =>
      await requestAddTicketNote({ ticketId: ticketId!, text }),
    onError: toastServerError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notesQueryKey(ticketId) });
    },
  });
};
